<template>
	<div id="text-page" data-aos="fade">
		<!-- Top -->
		<section class="top-section">
			<div class="container">
				<div class="row">
					<div class="col-12 col-lg-10 col-xl-8 mx-auto">
						<p class="hero-eyebrow">Legal</p>
						<h1 class="hero-title">Términos y Condiciones</h1>
						<p class="hero-date">Última actualización: Enero 2025</p>
					</div>
				</div>
			</div>
		</section>

		<!-- Contenido -->
		<section class="content-section">
			<div class="container">
				<div class="row">
					<div class="col-12 col-lg-10 col-xl-8 mx-auto">
						<b-card class="terms-card" body-class="terms-card-body">
							<div class="terms-block">
								<h2 class="terms-heading">1. Aceptación de Términos</h2>
								<p class="terms-text">
									Al acceder y utilizar unlawk, usted acepta estar sujeto a estos Términos y Condiciones. Si no está de
									acuerdo con alguna parte de estos términos, no podrá acceder al servicio. unlawk es una plataforma
									que conecta usuarios con abogados y firmas legales verificadas, facilitando el acceso a servicios
									legales de calidad.
								</p>
							</div>

							<div class="terms-block">
								<h2 class="terms-heading">2. Uso de la Plataforma</h2>
								<p class="terms-text mb-3">
									unlawk proporciona una plataforma tecnológica que facilita la conexión entre usuarios que buscan
									servicios legales y profesionales del derecho verificados. Nos comprometemos a:
								</p>
								<ul class="terms-list">
									<li>Verificar las credenciales de todos los abogados y firmas registradas</li>
									<li>Proporcionar un sistema de búsqueda asistido por IA para encontrar el especialista adecuado</li>
									<li>Facilitar la comunicación inicial entre usuarios y profesionales legales</li>
									<li>Mantener la privacidad y seguridad de la información compartida</li>
								</ul>
							</div>

							<div class="terms-block">
								<h2 class="terms-heading">3. Registro y Cuenta de Usuario</h2>
								<p class="terms-text mb-3">
									Para utilizar ciertos servicios de unlawk, debe crear una cuenta proporcionando información precisa y
									completa. Usted es responsable de:
								</p>
								<ul class="terms-list">
									<li>Mantener la confidencialidad de su contraseña</li>
									<li>Todas las actividades que ocurran bajo su cuenta</li>
									<li>Notificarnos inmediatamente de cualquier uso no autorizado</li>
									<li>Proporcionar información verdadera y actualizada</li>
								</ul>
							</div>

							<div class="terms-block">
								<h2 class="terms-heading">4. Servicios de Abogados</h2>
								<p class="terms-text">
									unlawk actúa únicamente como intermediario entre usuarios y profesionales legales. No somos un
									despacho legal ni proporcionamos asesoría legal directamente. Los servicios legales son prestados
									exclusivamente por los abogados y firmas registradas en nuestra plataforma, quienes son profesionales
									independientes responsables de sus propios servicios.
								</p>
							</div>

							<div class="terms-block">
								<h2 class="terms-heading">5. Pagos y Tarifas</h2>
								<p class="terms-text">
									Los honorarios por servicios legales son establecidos directamente entre el usuario y el abogado o
									firma legal. unlawk puede cobrar una comisión por el uso de la plataforma, la cual será claramente
									comunicada antes de cualquier transacción. Todas las tarifas mostradas incluyen impuestos aplicables
									según la legislación vigente.
								</p>
							</div>

							<div class="terms-block">
								<h2 class="terms-heading">6. Propiedad Intelectual</h2>
								<p class="terms-text">
									Todo el contenido de unlawk, incluyendo textos, gráficos, logotipos, iconos, imágenes, clips de audio
									y software, es propiedad de unlawk o de sus proveedores de contenido y está protegido por las leyes
									de propiedad intelectual mexicanas e internacionales.
								</p>
							</div>

							<div class="terms-block">
								<h2 class="terms-heading">7. Limitación de Responsabilidad</h2>
								<p class="terms-text">
									unlawk no será responsable por daños indirectos, incidentales, especiales o consecuentes que resulten
									del uso o la imposibilidad de usar nuestros servicios. Nuestra responsabilidad se limita a facilitar
									la conexión entre usuarios y profesionales legales verificados.
								</p>
							</div>

							<div class="terms-block">
								<h2 class="terms-heading">8. Modificaciones</h2>
								<p class="terms-text">
									Nos reservamos el derecho de modificar estos términos en cualquier momento. Los cambios entrarán en
									vigor inmediatamente después de su publicación en la plataforma. Es responsabilidad del usuario
									revisar periódicamente estos términos para estar al tanto de las actualizaciones.
								</p>
							</div>

							<div class="terms-block">
								<h2 class="terms-heading">9. Ley Aplicable</h2>
								<p class="terms-text">
									Estos términos se regirán e interpretarán de acuerdo con las leyes de los Estados Unidos Mexicanos.
									Cualquier disputa relacionada con estos términos estará sujeta a la jurisdicción exclusiva de los
									tribunales competentes de la Ciudad de México.
								</p>
							</div>

							<div class="terms-block mb-0">
								<h2 class="terms-heading">10. Contacto</h2>
								<p class="terms-text">
									Para cualquier pregunta sobre estos Términos y Condiciones, por favor contáctenos en:
								</p>
								<ul class="terms-contact list-unstyled">
									<li>
										<i class="fa-regular fa-envelope"></i>
										Email: legal@unlawk.com
									</li>
									<li>
										<i class="fa-regular fa-phone"></i>
										Teléfono: +52 (55) 1234-5678
									</li>
									<li>
										<i class="fa-regular fa-location-dot"></i>
										Dirección: Ciudad de México, México
									</li>
								</ul>
							</div>
						</b-card>
					</div>
				</div>
			</div>
		</section>
	</div>
</template>

<script>
export default {
	mounted() {
	}
}
</script>
